
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("iwt54", function(module, exports) {
$parcel$export(module.exports, "ExternalCollaboratorsSpaceInformationMessage", () => (parcelRequire("6lvbX")).ExternalCollaboratorsSpaceInformationMessage);
$parcel$export(module.exports, "ExternalCollaboratorsSpaceInformationMessageType", () => (parcelRequire("6lvbX")).ExternalCollaboratorsSpaceInformationMessageType);
$parcel$export(module.exports, "ExternalCollaboratorsSpaceInformationMessageBanner", () => (parcelRequire("buzhH")).ExternalCollaboratorsSpaceInformationMessageBanner);
$parcel$export(module.exports, "ExternalCollaboratorsSpaceInformationMessageFooter", () => (parcelRequire("a04nk")).ExternalCollaboratorsSpaceInformationMessageFooter);
$parcel$export(module.exports, "SpaceExternalListScrollable", () => (parcelRequire("lWGeX")).SpaceExternalListScrollable);

var $6lvbX = parcelRequire("6lvbX");


var $buzhH = parcelRequire("buzhH");


var $a04nk = parcelRequire("a04nk");


var $lWGeX = parcelRequire("lWGeX");


});

parcelRegister("lWGeX", function(module, exports) {
/* SpaceExternalListScrollable.tsx generated by @compiled/babel-plugin v0.36.1 */ /**
 * @Relay no-runtime
 */ /**
 * @graphql cc
 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $eSUdr = parcelRequire("eSUdr");


var $h82at = parcelRequire("h82at");

var $hiS1z = parcelRequire("hiS1z");


var $xQxzY = parcelRequire("xQxzY");


var $4KS7f = parcelRequire("4KS7f");


var $9hlns = parcelRequire("9hlns");


var $b3j2Y = parcelRequire("b3j2Y");


var $gvWVt = parcelRequire("gvWVt");


var $aqv4g = parcelRequire("aqv4g");


var $if3zY = parcelRequire("if3zY");

const $f64b63522d71861b$var$QUERY_PAGE_SIZE = 25; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f64b63522d71861b$var$SpinnerWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_y3gn1h6o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f64b63522d71861b$var$RowContainer = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1e0c1txw _2lx21bp4 _n3tdpxbi _j2v5idpf _11lvidpf _1xrki7uo _1vcu1r31 _15q5glyw _amo8nqa1 _17qn1r31 _1upvglyw _yrelnqa1 _6v781oa5",
            __cmplp.className
        ])
    });
});
const $f64b63522d71861b$var$UserInfoContainer = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1e0c1txw _2lx2vrvc",
            __cmplp.className
        ])
    });
});
const $f64b63522d71861b$var$i18n = (0, $h82at.defineMessages)({
    errorLoadingExternalEntities: {
        id: "space-guest-list.space-external-list-scrollable.failed-load",
        defaultMessage: "Failed to load. Please refresh."
    },
    loadMoreButton: {
        id: "space-guest-list.space-external-list-scrollable.load-more-button",
        defaultMessage: "Load more"
    }
});
function $f64b63522d71861b$export$826fff653a329e83(x) {
    return Boolean(x);
}
const $f64b63522d71861b$export$f0d50ef0c3273737 = ({ spaceKey: spaceKey, showGuestLozenge: showGuestLozenge = true })=>{
    const { data: data, loading: loading, error: error, fetchMore: fetchMore } = (0, $xQxzY.useQuery)((0, $eSUdr.default)`query SpaceExternalListScrollableSpaceExternalListQuery($spaceKey:String$start:Int$limit:Int){space(key:$spaceKey){id externalCollaboratorCount name directAccessExternalCollaborators(start:$start limit:$limit){nodes{displayName permissionType profilePicture{path}...on KnownUser{accountId email}}}}}`, {
        variables: {
            spaceKey: spaceKey,
            start: 0,
            limit: $f64b63522d71861b$var$QUERY_PAGE_SIZE
        }
    });
    if (error) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: error
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hiS1z.default), $f64b63522d71861b$var$i18n.errorLoadingExternalEntities));
    const loadMore = ()=>{
        if (data?.space?.directAccessExternalCollaborators?.nodes) fetchMore({
            variables: {
                spaceKey: spaceKey,
                start: data.space.directAccessExternalCollaborators.nodes.length,
                limit: $f64b63522d71861b$var$QUERY_PAGE_SIZE
            },
            updateQuery: (prevResults, { fetchMoreResult: fetchMoreResult })=>{
                return !(fetchMoreResult && fetchMoreResult.space) ? prevResults : {
                    space: {
                        id: fetchMoreResult.space.id,
                        externalCollaboratorCount: fetchMoreResult.space.externalCollaboratorCount,
                        name: fetchMoreResult.space.name,
                        directAccessExternalCollaborators: {
                            nodes: [
                                ...prevResults.space?.directAccessExternalCollaborators?.nodes || [],
                                ...fetchMoreResult.space.directAccessExternalCollaborators?.nodes || []
                            ],
                            __typename: 'PaginatedPersonList'
                        },
                        __typename: 'Space'
                    }
                };
            }
        });
    };
    const shouldShowLoadMore = data?.space?.directAccessExternalCollaborators?.nodes && data?.space?.externalCollaboratorCount > data?.space?.directAccessExternalCollaborators?.nodes.length;
    return loading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($f64b63522d71861b$var$SpinnerWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9hlns.default), {
        size: "small",
        testId: "space-externallist-scrollable-loading-spinner"
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", null, (data?.space?.directAccessExternalCollaborators?.nodes ?? []).filter($f64b63522d71861b$export$826fff653a329e83).map((user, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($f64b63522d71861b$var$RowContainer, {
            key: user.accountId || index
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($f64b63522d71861b$var$UserInfoContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aqv4g.GlobalPermissionsUserRow), {
            name: user.displayName ?? '',
            avatarSrc: user.profilePicture?.path,
            lozenge: showGuestLozenge && user.permissionType === (0, $if3zY.SitePermissionType).EXTERNAL ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gvWVt.ExternalCollaboratorUserLozenge), null) : null,
            subText: user.email,
            accountId: user.accountId ?? '',
            permissionType: user.permissionType,
            showQuickActionMenu: false,
            useProfileLink: true
        })))), shouldShowLoadMore && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4KS7f.default), {
        testId: "load-more-button",
        appearance: "default",
        onClick: loadMore,
        spacing: "default",
        shouldFitContainer: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hiS1z.default), $f64b63522d71861b$var$i18n.loadMoreButton)));
};
module.exports["SpaceExternalListScrollable"] = $f64b63522d71861b$export$f0d50ef0c3273737;

});

parcelRegister("gvWVt", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $4af2e88caf28e461$export$632b2aa69aba4fdd = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "iyBz0",
    name: "ExternalCollaboratorUserLozenge",
    loader: async ()=>(await (parcelRequire("lWBRe"))).ExternalUserLozenge
});
module.exports["ExternalCollaboratorUserLozenge"] = $4af2e88caf28e461$export$632b2aa69aba4fdd;

});

parcelRegister("lWBRe", function(module, exports) {

let $ff9c617ad0e949e6$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $ff9c617ad0e949e6$var$load("h4Nf7").then(()=>parcelRequire('9fywD'));

});

parcelRegister("aqv4g", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $c0727222b4e61271$export$5f22f1019f7a7dae = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "ceB-9",
    name: "GlobalPermissionsUserRow",
    loader: async ()=>(await (parcelRequire("8i7yC"))).UserRow
});
module.exports["GlobalPermissionsUserRow"] = $c0727222b4e61271$export$5f22f1019f7a7dae;

});

parcelRegister("8i7yC", function(module, exports) {

let $6095dde605a1159f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $6095dde605a1159f$var$load("6wr18"),
    $6095dde605a1159f$var$load("9Vlxk"),
    $6095dde605a1159f$var$load("hwq7s"),
    $6095dde605a1159f$var$load("j104l"),
    $6095dde605a1159f$var$load("1GCFv"),
    $6095dde605a1159f$var$load("h4Nf7"),
    $6095dde605a1159f$var$load("5uN9h"),
    $6095dde605a1159f$var$load("e7ZUf"),
    $6095dde605a1159f$var$load("gL8bn"),
    $6095dde605a1159f$var$load("hhss7"),
    $6095dde605a1159f$var$load("9AXkC"),
    $6095dde605a1159f$var$load("ffEVr"),
    $6095dde605a1159f$var$load("jXx9i"),
    $6095dde605a1159f$var$load("31vk5"),
    $6095dde605a1159f$var$load("7EorR"),
    $6095dde605a1159f$var$load("Wowvf"),
    $6095dde605a1159f$var$load("5RR9C"),
    $6095dde605a1159f$var$load("9qfB8"),
    $6095dde605a1159f$var$load("hA2SB")
]).then(()=>parcelRequire('ddkba'));

});

parcelRegister("if3zY", function(module, exports) {
/* tslint:disable */ /* eslint-disable */ // This file was automatically generated and should not be edited.
//==============================================================
// START Enums and Input Objects
//==============================================================
var $83c5dedbb8bb8ef1$export$8995abb8169b2cb8 = /*#__PURE__*/ function(SitePermissionType) {
    SitePermissionType["ANONYMOUS"] = "ANONYMOUS";
    SitePermissionType["APP"] = "APP";
    SitePermissionType["EXTERNAL"] = "EXTERNAL";
    SitePermissionType["INTERNAL"] = "INTERNAL";
    SitePermissionType["JSD"] = "JSD";
    return SitePermissionType;
}({});
module.exports["SitePermissionType"] = $83c5dedbb8bb8ef1$export$8995abb8169b2cb8;

});

parcelRegister("cLo2u", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $ep3mz = parcelRequire("ep3mz");


var $7zgzO = parcelRequire("7zgzO");

function $91bacb73ef37142f$export$12ed3d1363567203(spaceKey) {
    const $ = (0, $frIzR.c)(1);
    const [pageContextSpaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const { match: match } = (0, $42omo.useContext)((0, $7zgzO.RoutesContext));
    const routesContextSpaceKey = match?.params?.spaceKey;
    if (spaceKey) return spaceKey;
    if (pageContextSpaceKey) return pageContextSpaceKey;
    if (routesContextSpaceKey) return routesContextSpaceKey;
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = typeof document !== "undefined" ? document.querySelector("meta#confluence-space-key")?.content : null;
        $[0] = t0;
    } else t0 = $[0];
    const documentMetaSpaceKey = t0;
    return documentMetaSpaceKey ?? null;
}
module.exports["useSpaceKey"] = $91bacb73ef37142f$export$12ed3d1363567203;

});

parcelRegister("a04nk", function(module, exports) {
/* ExternalCollaboratorsSpaceInformationMessageFooter.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $6lvbX = parcelRequire("6lvbX");

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $becefe6e669c63cc$var$Wrapper = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1yt41ejb _bfhkysee",
            __cmplp.className
        ])
    });
});
const $becefe6e669c63cc$export$2c852baa71d8f552 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($becefe6e669c63cc$var$Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6lvbX.ExternalCollaboratorsSpaceInformationMessage), props));
module.exports["ExternalCollaboratorsSpaceInformationMessageFooter"] = $becefe6e669c63cc$export$2c852baa71d8f552;

});


//# sourceMappingURL=ExternalCollaboratorsSpaceInformationMessage.3b24b134.js.map
